/**
 * Redux-enabled component for the New User app, which is used to provide new
 * users of Sparx Web with their passwords for the first time
 */

import { connect } from 'react-redux';

import { selectCurrentViewType } from 'phoenix2/state/views/selectors';
import { VIEWS_KEY } from 'phoenix2/state/views/reducers';
import { getConfigParameter } from 'phoenix2/state/config-params/selectors';
import { getFeatureFlag } from 'phoenix2/state/feature-flags/selectors';
import { FEATURE_FLAG_NEWUSER_STUDENT_CHOOSE_PASSWORD } from 'phoenix2/state/feature-flags';

import PureNewUser from './new-user.jsx';

const mapStateToProps = state => {
    const viewType = selectCurrentViewType(state);
    const disableAnimations = getConfigParameter(state, 'disableAnimations');
    const usingChoosePassword = getFeatureFlag(state, FEATURE_FLAG_NEWUSER_STUDENT_CHOOSE_PASSWORD);

    return {
        transition: state.get(VIEWS_KEY).transition,
        viewType,
        alert: state.get('alert'),
        disableAnimations,
        usingChoosePassword,
    };
};

const connectSparxWeb = connect(mapStateToProps, null);

export const NewUser = connectSparxWeb(PureNewUser);
export default NewUser;

NewUser.displayName = 'NewUserContainer';
